import React from 'react';
import NumericFunction from "../../../utils/NumericFunction";

const PrintType7Header = ({data}) => {
  let logoUrl = data.headerAndFooter.logo;

  if (window.location.hostname === "localhost") {
    logoUrl = "http://localhost/Git/Delsa/" + logoUrl

  }

  return (
    <div className={""}>

      <div className={"d-flex flex-wrap w-100 headerPrintType7 text-end"}>
        <div style={{flex: '80%'}} className={"d-flex flex-wrap w-100 text-end"}>
          {/*<div>{dateLabel}: {date}</div>*/}
          {/*<div>{timeLabel}: {time}</div>*/}
          {/*<div>{userLabel}: {user}</div>*/}
          {data.headerAndFooter.header.map((v, index) => {
            if (v.id === 'Memo100') {
              return null
            }
            return <div
              key={index}
              className={"mx-3"}
              // style={{flex: (50 / data.headerAndFooter.header.lenght)}}
              style={v.style ? v.style : {}}
            >{v.label}: {NumericFunction.e2p(v.value)}</div>
          })}

          {/*</div>*/}
          {/*<div>*/}
          {/*  <div>{nameLabel}: {name}</div>*/}
          {/*  <div>{formNameLabel}: {formName}</div>*/}

        </div>
        <div style={{flex: '19%'}} className={"imgParent"}>{logoUrl && <img src={logoUrl} alt={''}/>}</div>

      </div>
    </div>
  );
};

export default PrintType7Header;
